// How a deposit order was created. The backend records it since 2025-08-27 (older orders carry
// null); 'manual' marks orders an operator created by hand through Add balance.
export type IOrderProtocol = 'h2h' | 'hosted_page' | 'intent' | 'manual';

// Manual first: finding operator-created orders is what the filter exists for
export const ORDER_PROTOCOL_LABELS: Record<IOrderProtocol, string> = {
  manual: 'Manual',
  h2h: 'H2H',
  hosted_page: 'Hosted page',
  intent: 'Intent',
};

export const ORDER_PROTOCOL_OPTIONS = (Object.keys(ORDER_PROTOCOL_LABELS) as IOrderProtocol[]).map(
  id => ({ id, label: ORDER_PROTOCOL_LABELS[id] }),
);

// Unknown values (a protocol added on the backend later) fall back to the raw string
export const getOrderProtocolLabel = (protocol: string) =>
  ORDER_PROTOCOL_LABELS[protocol as IOrderProtocol] ?? protocol;
